export enum ContentMode {
  PACKAGE = 'package',
  PREVIEW = 'preview',
}
